module.exports = __webpack_public_path__ + "media/images/bnr-insta-stories-sm-c4912519e2742bdfdd5ddc7a997c715d.png";